import { render } from "./MarkdownPage.vue?vue&type=template&id=6574e7f0&scoped=true&ts=true"
import script from "./MarkdownPage.vue?vue&type=script&lang=ts"
export * from "./MarkdownPage.vue?vue&type=script&lang=ts"

import "./MarkdownPage.vue?vue&type=style&index=0&id=6574e7f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6574e7f0"]])

export default __exports__